import { Spinner } from '../../public/site/siteUtils.js';
import { AuthorizationError } from './AuthorizationError.js';
import { AuthorizationOwnerChange } from './AuthorizationOwnerChange.js';
import type { AuthorizationRequestState } from '../../common/types/states.js';

export interface AuthorizationSceneProps {
  authorizationRequest: AuthorizationRequestState;
}

export const AuthorizationScene = ({ authorizationRequest }: AuthorizationSceneProps) => {
  if (authorizationRequest.loading) {
    return <Spinner />;
  } else if (authorizationRequest.errors) {
    return <AuthorizationError errors={authorizationRequest.errors} />;
  } else {
    return <AuthorizationOwnerChange authorizationRequest={authorizationRequest} />;
  }
};
